import { useCallback } from "react";

import { Msg, Spinner } from "@shared/components";
import { useLocalStorage } from "@shared/hooks";
import { useWebcam } from "@shared/hooks/useWebcam";
import { LocalStorageConstants } from "@shared/services/enums";

import { HelpLink } from "../../helpLink/HelpLink";

interface CameraPermissionStepProps {
  onPermissionGranted: (permissionGranted: boolean) => void;
  faceVerified: boolean;
}

export const CameraPermissionStep = ({
  onPermissionGranted,
}: CameraPermissionStepProps) => {
  const [localStorageWebcamId] = useLocalStorage(
    LocalStorageConstants.Webcam,
    "",
  );

  useWebcam({
    defaultWebcamId: localStorageWebcamId,
    onConnect: useCallback(() => {
      onPermissionGranted(true);
    }, []),
  });

  return (
    <div className="code-editor-exam-detail__camera-permission-modal">
      <Spinner
        size="small"
        className="code-editor-exam-detail__camera-permission-modal__spinner"
      />
      <Msg
        className="code-editor-exam-detail__camera-permission-modal__message"
        id="editor-exam-detail.modals.fourthModal.loading-text"
      />
      <HelpLink />
    </div>
  );
};
